


































import Vue from 'vue'
import Component from 'vue-class-component'
import { Notification } from 'element-ui'
import { mapState } from 'vuex'

import { dropbox } from '@/api/dropbox'
import { Page } from '@/interfaces/product'

const BaseVue = Vue.extend({
  computed: {
    ...mapState(['pages'])
  }
})

@Component
export default class Coords extends BaseVue {
  coords: any = null
  imgSrc = ''

  async created () {
    await this.$store.dispatch('loadConfig')

    setTimeout(async () => {
      const page = +this.$route.params.page
      const foundPage: Page = this.pages.find((_page: Page) => _page.Pagina === page)

      if (foundPage) {
        try {
          this.imgSrc = (await dropbox.filesGetTemporaryLink({ path: `/Paginas/${foundPage.Archivo}` })).link
        } catch (error) {
          console.log(`Error while getting /Paginas/${foundPage.Archivo}`)
        }
      }
    }, 100)
  }

  nextCoord () {
    location.href = `/coords/${Number(this.$route.params.page) + 1}`
  }

  prevCoord () {
    location.href = `/coords/${Number(this.$route.params.page) - 1}`
  }

  async copyCoords (e: MouseEvent) {
    const img = e.target as HTMLImageElement
    const clientRect = img.getBoundingClientRect()

    const x = `${(e.pageX - clientRect.x) / img.clientWidth * 100}%`
    const y = `${(e.pageY - clientRect.y) / img.clientHeight * 100}%`

    await navigator.clipboard.writeText(`${x},${y}`)

    this.coords = {
      top: y,
      left: x
    }

    Notification.success({
      title: 'Éxito',
      message: 'Coordenadas copiadas',
      duration: 2000
    })
  }

  removeCoords (e: MouseEvent) {
    e.preventDefault()

    this.coords = null
  }
}
